<router>
{
    name: 'Client Activity',
}
</router>

<template lang="pug">
.analytics_client-activity
    v-container(fluid)
        v-card(light)
            v-card-title Client API Action
            v-card-subtitle Latest only
            v-card-text
                v-row(align="center")
                    v-col(cols='auto')
                        v-text-field(
                            v-model="search"
                            label="Search"
                            clearable
                            color='brand'
                        )
                    v-col(cols="auto")
                        v-btn(
                            @click="getActivity"
                            color="brand"
                            small
                            class="white--text"
                            :disabled="isRefreshing || isAutoRefresh"
                        ) Refresh
                    v-col(cols="auto")
                        v-tooltip(top)
                            template(v-slot:activator="{ on, attrs }")
                                v-btn(
                                    v-bind="attrs"
                                    v-on="on"
                                    :color="isAutoRefresh ? 'red' : 'green'"
                                    small
                                    class="white--text"
                                    @click="toggleAutoRefresh"
                                )
                                    | {{ isAutoRefresh ? 'Stop Auto-Refresh' : 'Start Auto-Refresh' }}
                            span The refresh rate is 30 seconds

                    v-col(cols="auto")
                        span(class="last-refreshed" style="margin-left: 10px; font-size: 0.9em;")
                            | Last Refreshed: {{ lastRefreshed }}
                v-row
                    v-col
                        v-data-table(
                            light
                            :headers="activityHeaders"
                            :items="activity"
                            :search="search"
                            :items-per-page="10"
                            sort-by="reported_at"
                            sort-desc=true
                            item-key="id"
                            groupBy="system_id"
                        )

                            template(v-slot:item.system_id="{ item }")
                                span.system-id-column {{ item.system_id }}

                            template(v-slot:item.reported_at="{ item }")
                                div
                                    | {{ formatDate(item.reported_at, 'date') }}
                                    | {{ formatDate(item.reported_at, 'time') }}
</template>

<script>

import {DateTime} from 'luxon';
export default {
    name: 'ClientActivity',
    meta: {
        role: 'analytics-client'
    },
    props: {
        // Define your props here
    },
    data () {
        return {
            search: '',
            activity: [],
            activityHeaders: [
                { text: 'System', value: 'system_id' },
                { text: 'Reported At', value: 'reported_at', filterable: false },
                { text: 'Action', value: 'action' },
                { text: 'version', value: 'version' },
                { text: 'Message', value: 'message'},
                { text: 'Error', value: 'error'}
            ],
            lastRefreshed: DateTime.now().toFormat('MM/dd hh:mm:ss a ZZZZ'),
            isRefreshing: false,
            isAutoRefresh: false,

        };
    },
    methods: {
        initialize () {
            this.getActivity();
        },
        getActivity () {
            this.isRefreshing = true;
            this.socketEmit('getClientActivity', null, ({activity, error}) => {
                if(error) {
                    this.$set(this, 'error', error);
                    console.error('Error fetching tasks:', error);
                } else {
                    this.$set(this, 'activity', activity);
                    this.lastRefreshed = DateTime.now().toFormat('M/dd hh:mm:ss a ZZZZ');
                    const refreshedElement = this.$el.querySelector('.last-refreshed');
                    if (refreshedElement) {
                        refreshedElement.classList.add('refresh-highlight');
                        setTimeout(() => {
                            refreshedElement.classList.remove('refresh-highlight');
                        }, 1000);
                    }
                }
                this.isRefreshing = false;
            });
        },

        toggleAutoRefresh () {
            if (this.isAutoRefresh) {
                // Stop auto-refresh
                clearInterval(this.autoRefreshInterval);
                this.autoRefreshInterval = null;
                this.isAutoRefresh = false;
            } else {
                // Start auto-refresh
                this.autoRefreshInterval = setInterval(this.fetchQueue, 30000);
                this.isAutoRefresh = true;
            }
        },

        formatDate (dateString, type) {
            if (!dateString) return '';
            if (type === 'date') {
                return DateTime.fromISO(dateString).toFormat('MM/dd');
            }
            if (type === 'time') {
                return DateTime.fromISO(dateString).toFormat('h:mm:ss a');
            }
            return '';
        },

    },
    mounted () {
        this.initialize();
    }
};
</script>

<style scoped>
.v-container {
    max-width: 900px;
}
.system-id-column {
    font-family: 'Times New Roman', 'Baskerville', serif;
}
.refresh-highlight {
  background-color: yellow;
  transition: background-color 1s ease-out;
}
</style>
